module.exports = "<div class=\"thinker\">\r\n    <div class=\"bspinner\">\r\n        <div class=\"bounce1\"></div>\r\n        <div class=\"bounce2\"></div>\r\n        <div class=\"bounce3\"></div>\r\n    </div>\r\n</div>\r\n<div class=\"alert-content\">\r\n    <table>\r\n        <tr>\r\n            <td class=\"jurisdiction-enabled\"><b>Enabled</b></td>\r\n            <td class=\"jurisdiction-name\"><b>Jurisdiction</b></td>\r\n        </tr>\r\n    </table>\r\n    <div id=\"alerts-jurisdiction-list-region\">\r\n    </div>\r\n</div>\r\n<div class=\"alerts-message\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/alerts-jurisdictions.html
// module id = 368
// module chunks = 1